import Vue from "vue";
import App from "./App.vue";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: ""
});
Vue.config.productionTip = false;


import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
new Vue({
  render: h => h(App)
}).$mount("#app");
